import React from "react";
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBContainer,
  MDBNavbar,
  MDBBtn,
  MDBIcon,
} from "mdb-react-ui-kit";
import Cardiology from "../img/Landing page device mockup.svg";
import "../css/specilities.css";
export default function App() {
  return (
    <MDBContainer fluid className="p-0 bg-white">
      <div className="container py-5">
        <div className="row">
          <div className="col-12">
            <div className="section-title pb-2">
              {/* <div className="title mb-4 display-heading AcerhealthTextPurple text-center" style={{fontSize:'45px',fontFamily:'EBGarmond semi bold',fontWeight:'bold'}}> */}
              <h3
                className="title mb-4 display-heading AcerhealthTextPurple text-center speciality"
                style={{ fontFamily: 'Lora, serif', fontWeight: 'bold' }}
              >
                Medical Billing Specialities
              </h3>
              <p
                className="para-desc mx-auto mb-0 justify-content-left speciality1"
                style={{
                  fontFamily: "Alegreya Sans",
                  fontWeight: "500",
                  textAlign: "justify"  // <-- added justification
                }}
              >
                At AcerHealth, we deliver end-to-end <b>medical billing services</b> tailored to a wide range of specialties across the <b>USA.</b> From patient registration and insurance
                verification to accurate
                <a
                  href="https://www.cms.gov/cms-guide-medical-technology-companies-and-other-interested-parties/coding/overview-coding-classification-systems"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#007BFF", textDecoration: "none", margin: "0 5px" }}
                >
                  CPT and ICD-10 coding
                </a>
                <b>support,</b> charge capture, and claim submission, our expert team manages every phase of the <b>revenue cycle</b> with precision.
                We offer specialty-specific billing solutions designed to optimize reimbursements and reduce denials. As a trusted <b>specialty billing company in the USA,</b> we help
                <b>healthcare providers</b> focus on delivering exceptional care while we handle the complexities of <b>outsourced billing and coding for medical providers.</b>
              </p>
            </div>
          </div>
        </div>
        {/* <div className="row mb-4">
          <div className="col-lg-10 col-md-6 col-12">
              <div className="content mt-3 text-center"> */}
        <div className="text-center">
          <img class="img-fluid profile" src={Cardiology} alt="Cardiology" />
        </div>

        <div className="row text-center">
          <a href="/Cardologyspeciality">
            <MDBBtn style={{ background: '#3B0075' }}>Learn More</MDBBtn>
          </a>
        </div>
      </div>
    </MDBContainer>
  );
}
